export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "http://localhost:3000"
export const SUGGESTED_PROMPTS = ["Hallo!", "2 matkul terbaik di sisfo", "Kasih Rekomendasi mata kuliah dong!", "matkul terbaik yang pernah saya ambil"];

// local storage keys and cypher key (contant folding akan memakai nilai di env jika ada, jadi fallback value tidak akan pernah dipakai di production, hanya untuk development lokal saja)
// Update jika: ada perubahan besar pada struktur data (reset localStorage browser user)
export const STORAGE_VERSION = "v2.4"; // LLM Backend, TFJS+RAG
export const USER_STORAGE_KEY = import.meta.env.VITE_USER_STORAGE_KEY || "user_data";
export const AVAILABLE_MATKULS_STORAGE_KEY = import.meta.env.VITE_AVAILABLE_MATKULS_STORAGE_KEY || "available_matkuls";

// chat model key & achievement key
export const ACHIEVEMENT_TAGS_KEY = import.meta.env.VITE_ACHIEVEMENT_TAGS_KEY || "achievement";
export const TUTORIAL_YT =
    "https://www.youtube.com/embed/rqhKGMPKtew?rel=0&modestbranding=1&iv_load_policy=3";
export const ghMap: Record<string, string> = {
    "4": "A",
    "3.5": "B+",
    "3": "B",
    "2.5": "C+",
    "2": "C",
    "1.5": "D+",
    "1": "D",
    "0.5": "E+",
    "0": "E"
}